import { EngineIncomingMessage } from "@bennara/shared";

export const validateEngineIncomingMessage = (
  message: unknown,
): EngineIncomingMessage => {
  if (typeof message !== "object" || message === null || !("type" in message)) {
    throw new Error("Invalid message");
  }

  return message as EngineIncomingMessage;
};
